import Nav from "./nav"
import RosetteOffers from "./rosette-offers"

document.addEventListener("DOMContentLoaded", function () {
    Nav(jQuery)
    RosetteOffers(jQuery)
})
